import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, CircularProgress, Box, Stack, Chip
} from '@mui/material';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import { gradientButtonSx, gradientTextSx, primaryChipSx, SECONDARY } from '../../utils/colors';

const AddProblemsModal = ({ onClose, onSubmit, loading = false }) => {
  const [links, setLinks] = useState('');

  const lineCount = links.split('\n').map((l) => l.trim()).filter(Boolean).length;

  const handleSubmit = (e) => {
    e.preventDefault();
    const linkArray = links.split('\n').map((l) => l.trim()).filter(Boolean);
    if (!linkArray.length) return;
    onSubmit(linkArray);
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogTitle sx={{ fontWeight: 800, pb: 0 }}>
        <Typography variant="h6" fontWeight={800} sx={gradientTextSx}>
          Add Problems
        </Typography>
      </DialogTitle>
      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <LinkRoundedIcon fontSize="small" sx={{ color: SECONDARY }} />
            <Typography variant="body2" color="text.secondary">
              Paste LeetCode problem URLs — one per line.
            </Typography>
            {lineCount > 0 && (
              <Chip
                label={`${lineCount} link${lineCount > 1 ? 's' : ''}`}
                size="small"
                sx={{ ...primaryChipSx, ml: 'auto !important' }}
              />
            )}
          </Stack>
          <TextField
            multiline rows={8} value={links}
            onChange={(e) => setLinks(e.target.value)}
            placeholder={
              'https://leetcode.com/problems/two-sum/\nhttps://leetcode.com/problems/valid-parentheses/\nhttps://leetcode.com/problems/binary-search/'
            }
            required fullWidth size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2, fontFamily: 'monospace', fontSize: '0.85rem',
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button onClick={onClose} disabled={loading} sx={{ textTransform: 'none', borderRadius: 2 }}>
            Cancel
          </Button>
          <Button
            type="submit" variant="contained" disabled={loading}
            sx={{ ...gradientButtonSx, px: 3 }}
          >
            {loading ? <CircularProgress size={18} color="inherit" /> : 'Add Problems'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default AddProblemsModal;
